import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SharedStateService {
  private heatRecoveryUsedSubject = new BehaviorSubject<boolean>(false);
  heatRecoveryUsed$ = this.heatRecoveryUsedSubject.asObservable();

  setHeatRecoveryUsed(value: boolean) {
    this.heatRecoveryUsedSubject.next(value);
  }

  getHeatRecoveryUsed(): boolean {
    return this.heatRecoveryUsedSubject.getValue();
  }

  // Adiabatic Efficiency state
  private adiabaticEfficiencySubject = new BehaviorSubject<boolean>(true);
  adiabaticEfficiency$ = this.adiabaticEfficiencySubject.asObservable();

  setAdiabaticEfficiency(value: boolean) {
    this.adiabaticEfficiencySubject.next(value);
  }

  // Total Efficiency state
  private totalEfficiencySubject = new BehaviorSubject<boolean>(true);
  totalEfficiency$ = this.totalEfficiencySubject.asObservable();

  setTotalEfficiency(value: boolean) {
    this.totalEfficiencySubject.next(value);
  }

  // Submit event for table visibility
  private submitClickedSubject = new Subject<void>();
  submitClicked$ = this.submitClickedSubject.asObservable();

  triggerSubmitClicked() {
    this.submitClickedSubject.next();
  }

  // Motor selection states
  private motor400kWSubject = new BehaviorSubject<boolean>(false);
  private motor500kWSubject = new BehaviorSubject<boolean>(false);
  private motor580kWSubject = new BehaviorSubject<boolean>(false);
  private motor650kWSubject = new BehaviorSubject<boolean>(true);

  motor400kW$ = this.motor400kWSubject.asObservable();
  motor500kW$ = this.motor500kWSubject.asObservable();
  motor580kW$ = this.motor580kWSubject.asObservable();
  motor650kW$ = this.motor650kWSubject.asObservable();

  setMotor400kW(value: boolean) {
    this.motor400kWSubject.next(value);
  }

  setMotor500kW(value: boolean) {
    this.motor500kWSubject.next(value);
  }

  setMotor580kW(value: boolean) {
    this.motor580kWSubject.next(value);
  }

  setMotor650kW(value: boolean) {
    this.motor650kWSubject.next(value);
  }

  getMotorStates() {
    return {
      motor400kW: this.motor400kWSubject.getValue(),
      motor500kW: this.motor500kWSubject.getValue(),
      motor580kW: this.motor580kWSubject.getValue(),
      motor650kW: this.motor650kWSubject.getValue(),
    };
  }
}
